<template>
    <el-container style="height: 100%" >
        <el-main style="padding: 0">
            <div style="height: 100%; width: 100%;">
                <img src="../assets/img/main-show.png" width="100%" height="100%"/>
                <img src="../assets/img/logo.png" width="170px" height="33px" style="position: absolute; top: 25px; left: 34px"/>
                <div style="height: 140px; width: 100%; background-color: #2563AA; position: absolute; top: 32%" >
                    <p style="font-family: 方正楷体; color: white; font-size: 42px; position: absolute; left: 20%; top: 34px">起重物流装备行业工业互联网平台</p>
                    <p style="font-family: 方正楷体; color: white; font-size: 24px; position: absolute; left: 19.5%; top: 77px">Industrial Internet Platform for Crane Logistics Equipment Industry</p>
                </div>
                <div class="login-box" style="position: absolute; top: 22%; right: 160px">
                    <h1 style="height: 41px; margin-bottom: 20px">用户登录</h1>
                    <div class="login-form-box">
                        <el-form ref="form" :model="loginUser" :rules="loginRules">
                            <el-form-item prop="username" >
                                <div style="display: flex;">
                                    <div style="width: 76px; margin: 0 auto">用户名</div>
                                    <el-input style="width: 295px" v-model="loginUser.username" placeholder="用户名" @keyup.enter.native="submitForm()"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item prop="password">
                                <div style="display: flex;">
                                    <div style="width: 76px; margin: 0 auto">密 码</div>
                                    <el-input style="width: 295px" v-model="loginUser.password" placeholder="密码" show-password @keyup.enter.native="submitForm()"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <div style="display: flex; flex-direction: row-reverse">
                                    <el-checkbox v-model="loginUser.knowMe">记住密码</el-checkbox>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <div style="display: flex; flex-direction: row-reverse">
                                    <div class="login-btn" @click="submitForm()" >登录</div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </el-main>
        <el-footer class="login-foot" height="150px">
            <div class="footer-box">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <img src="../assets/img/hope-icon.png" width="20px">
                        <span>公司愿景</span>
                        <p>用卫华人的智慧和力量，让全世界的劳动者轻松起来！</p>
                    </el-col>
                    <el-col :span="8">
                        <img src="../assets/img/head-icon.png" width="20px">
                        <span>合作理念</span>
                        <p>打过一次交道，便永远是朋友！</p>
                    </el-col>
                    <el-col :span="8">
                        <img src="../assets/img/header-icon.png" width="20px">
                        <span>企业精神</span>
                        <p>敬业奉献，追求卓越！</p>
                    </el-col>
                </el-row>
                <el-row>
                    <span>公司使命：</span>
                    <p>用我们辛勤的劳动，把产品做到精益求精，让全世界产业工人从繁重的体力劳动中解放出来，为人类创造美好的生活空间。</p>
                </el-row>
            </div>
        </el-footer>
        <el-dialog
                title="卫华供应商平台使用协议"
                :visible.sync="agreementShowFlag"
                width="30%"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
        >
            <use-agreement></use-agreement>
            <div slot="footer" class="dialog-footer">
                <el-button @click="acceptAgreement(false)">不接受</el-button>
                <el-button type="primary" @click="acceptAgreement(true)">接受</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<script>
    import useAgreement from '../component/use-agreement'
    import {setCookie, delCookie, getCookie} from '../cookie';
    export default {
        name: "login",
        components: {
            useAgreement
        },
        data(){
            return{
                agreementShowFlag: false,
                userData: {},
                loginUser: {
                    code: '',
                    username: '',
                    password: '',
                    grant_type: 'password',
                    scope: 'user_info',
                    knowMe: false
                },
                loginRules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            submitForm(){
                this.$refs.form.validate((valid) => {
                    if(!valid) {
                        return;
                    }
                    window.sessionStorage.clear();
                    this.$store.dispatch("login/loadToken", this.loginUser).then((res) => {
                        if(res && res.status === 200){
                            if(this.loginUser.knowMe) {
                                setCookie('userInfo',this.loginUser.username + '&' + this.loginUser.password, 1440 * 3);
                            }
                            if (res.data.access_token !== '') {
                                window.sessionStorage.setItem('wh-access-token', res.data.access_token);
                                window.sessionStorage.setItem('wh-refresh-token', res.data.refresh_token);
                                window.sessionStorage.setItem('wh-expires-in', res.data.expires_in);
                                this.$store.dispatch('login/loadUser').then((res) => {
                                    let data = res.data.data;
                                    if (data) {
                                        this.userData = data;
                                        var year = new Date().getFullYear();
                                        if(!data.loginTime || data.loginTime !== (year + '')) {
                                            //展示 条例
                                            this.agreementShowFlag = true;
                                        } else {
                                            window.sessionStorage.setItem('wh-user', JSON.stringify(data));
                                            this.agreementShowFlag = false;
                                            this.$router.push('/index');
                                        }
                                    }
                                });
                            } else {
                                this.$message({
                                    'message': '登录出现错误',
                                    'type': 'error',
                                    'duration': 3 * 1000
                                });
                            }
                        }
                    });
                });
            },
            acceptAgreement(isAccept) {
                this.agreementShowFlag = false;
                if(isAccept) {
                    //修改 登录时间
                    this.$store.dispatch('system/user/acceptAgreement').then((res) => {
                        if(res.code === '200') {
                            window.sessionStorage.setItem('wh-user', JSON.stringify(this.userData));
                            this.$router.push('/index');
                        }else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                } else {
                    window.sessionStorage.clear();
                }
            }
        },
        mounted () {
            let userInfo = getCookie('userInfo');
            if(userInfo) {
                let index = userInfo.indexOf('&');
                this.loginUser.username = userInfo.substring(0, index);
                this.loginUser.password = userInfo.substring(index + 1);
                this.loginUser.knowMe = true;
            }
        }
    }
</script>

<style scoped>
    .bg-blue {
        background-color: #2563AA;
    }
    .el-main {
        background-color: #F8F8F8;
        min-height: 500px;
        overflow: hidden;
        display: flex;
        display: -webkit-flex;
        align-items: center;
    }
    .el-input {
        box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
        margin-bottom: 5px;
    }
    .el-form-item {
        margin-bottom: 30px;
    }
    .el-form .el-checkbox {
        line-height: 44px;
        float: left;
    }
    .login-foot {
        padding-top: 20px;
        background-color: #F4F4F4;
    }
    .footer-box img {
        vertical-align: bottom;
    }
    .footer-box span {
        color: #2563AA;
        font-size: 16px;
    }
    .footer-box p {
        margin-top: 5px;
        margin-left: 25px;
        font-size: 12px;
    }
    .header-show {
        position: relative;
    }
    .header-show .adornment {
        transform:rotate(180deg);
        -webkit-transform:rotate(180deg);
        -moz-transform:rotate(180deg);
        position: absolute;
        right: 0;
        top: 0;
    }
    .logo-show {
        width: 500px;
        position: absolute;
        top: calc(50% - 24px);
        display: flex;
        align-items: center;
    }
    .logo-show img {
        vertical-align: middle;
        float: left;
    }
    .logo-show h1 {
        float: left;
        margin-left: 10px;
        color: white;
        font-size: 32px;
        width: 140px;
        border-right: 1px solid white;
        height: 48px;
        display: block;
        line-height: 48px;
    }
    .logo-show h2 {
        margin-left: 10px;
        color: white;
        font-family: "方正楷体";
        font-size: 32px;
        font-weight: normal;
    }
    .header-right {
        height: 100%;
        float: right;
        display: flex;
        align-items: center;
    }
    .main-show {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        padding: 20px 0;
    }
    .main-show img {
        float: left;
        display: block;
    }
    .login-box {
        float: left;
        width: 452px;
        height: 298px;
        border: 1px solid rgba(255, 255, 255, 0);
        border-radius: 3px;
        text-align: center;
        box-shadow: 0 1px 5px 0 rgba(0,0,0,.4);
        background-color: white;
        padding-top: 20px;
    }
    .login-box .login-form-box {
        width: 376px;
        margin: 0 0;
    }
    /*.login-form-box .el-form-item:last-child {*/
    /*    padding-top: 14px;*/
    /*}*/
    .login-box h1 {
        display: block;
        height: 110px;
        color: #2563AA;
        font-weight: normal;
        letter-spacing: 5px
    }
    .login-box h1::after{
        content:'';
        margin-right: -5px;
    }
    .login-btn {
        width: 295px;
        height: 43px;
        background: #2563AA;
        border-radius: 4px;
        cursor: pointer;
        color: white;
    }
    .login-btn:hover {
        background: rgba(37, 99, 170, .9);
    }
    .footer-box {
        height: 100%;
        width: 1200px;
        margin: 0 auto;
    }
    .footer-box .el-row:last-child {
        text-align: center;
        margin-top: 30px;
    }
    .footer-box .el-row:last-child span {
        color: #2563AA;
        font-size: 16px;
    }
    .footer-box .el-row:last-child p {
        display: inline;
        margin-left: 0;
    }
    .el-form-item {
        margin-bottom: 5px !important;
    }
</style>